import { Component, OnInit } from "@angular/core";

import { PwaService } from "./pwa.service";


@Component({
    selector: "app-install",
    templateUrl: "./app-install.component.html",
})
export class AppInstallComponent implements OnInit {
    showBanner: boolean = false;

    constructor(public pwaService: PwaService) {}

    ngOnInit(): void {
        this.showBanner = this.pwaService.isInstallationEnabled && 
            !this.pwaService.wasDeclined && 
            (this.pwaService.appInstallationAvailable || this.pwaService.isApplePwaCompatibleDevice)
    }
    
    installApp(): void {
        this.pwaService.installationPromptEvent.prompt();
    }

    askLater(): void {
        this.pwaService.declinePrompt();
    }

    onHide(): void {
        this.pwaService.declinePrompt();
    }


}